export const deClientPortalInternalApprovalModal = {
    actions: {},
    visibilityConsequence: 'Alle Anmerkungen zu diesem Entwurf für den Gutachter/die Gutachterin sichtbar machen',
    itemLabel: 'Fondsseitige Freigabe erteilen',
    confirmationLabel: 'Ich bestätige, dass ich diesen Entwurf freigebe.',
}
